<script setup lang="ts">
import { WidthVariants } from '~/types/Content'
import { ActionFields } from '~/components/cms/Action/actionHelpers'

type TwoUpCardPanelProps = {
  title?: string
  actions: ActionFields[]
  width?: WidthVariants
}

const props = defineProps<TwoUpCardPanelProps>()
</script>

<template>
  <section class="utility-panel utility-panel--grid-links" data-testid="utility-panel">
    <div :class="width === 'wide' ? 'container' : 'container-custom'">
      <div class="utility-panel__header">
        <h3 class="utility-panel__title heading-2" v-if="title">{{ title }}</h3>
      </div>
      <div class="utility-panel__actions">
        <template v-for="action in actions">
          <Action v-if="action.fields" data-testid="utility-panel__action" v-bind="action" />
        </template>
      </div>
    </div>
  </section>
</template>

<style lang="postcss">
.utility-panel--grid-links {
  margin-bottom: var(--component-space);

  .container-custom {
    margin: 0 auto;
    padding-inline: var(--space-70);

    @media (--tablet) {
      padding-inline: var(--space-20);
      max-width: 26.5rem;
    }
    @media (--desktop) {
      padding-inline: var(--space-50);
      max-width: 42rem;
    }
  }

  .utility-panel__header {
    text-align: center;
  }

  .utility-panel__title {
    margin-bottom: var(--space-70);
  }

  .utility-panel__actions {
    width: 100%;
    margin: var(--space-60) auto 0 auto;
    display: grid;
    grid-template-columns: minmax(0, 1fr);
    column-gap: var(--space-60);
    row-gap: var(--space-60);
    overflow: hidden;

    a {
      font-weight: bold;
      letter-spacing: var(--letter-spacing-1);
      text-decoration: none;
      text-transform: uppercase;
      min-height: 3rem;
      padding: 0.815rem 2.6rem 0.815rem 1rem;
      border: 1px solid var(--border-neutral-30);
      position: relative;
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: flex-start;
      gap: var(--space-30);
      transition: var(--transition-1);

      &:after {
        content: '';
        display: inline-block;
        width: 1.5rem;
        height: 1rem;
        background: url('~/assets/sprite/svg/chevron-right.svg') no-repeat center;
        position: absolute;
        right: var(--space-50);
        transition: var(--transition-1);
      }

      .icon {
        display: flex;
        align-items: center;
        .icon__img {
          width: 1.25rem;
          height: 1.25rem;
        }
      }

      &:hover {
        color: currentColor;
        border: 1px solid var(--border-dark-10);
        &:after {
          transform: translateX(0.5rem);
        }
      }
      &:active {
        outline: 2px solid var(--border-dark-10);
        outline-offset: -2px;
      }
    }

    @media (--desktop) {
      grid-template-columns: repeat(2, minmax(0, 1fr));
    }
  }
}
</style>
.
